module.exports = __webpack_public_path__ + "img/search.045bab47.png";